
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ppe-disposal",
      function () {
        return require("private-next-pages/ppe-disposal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ppe-disposal"])
      });
    }
  